import React from 'react'
import { ChatCommonPage } from '../../../commonPage'
import { useTranslation } from 'react-i18next';

const CancelledChats = ({ loginData }) => {
    const { t } = useTranslation();
    const onSearchClick = () => {


    }
    return (
        <ChatCommonPage
            pageHeading={t("chatPage.Cancelled.pageHeading")}
            loginData={loginData}
            chatTableHeading={t("chatPage.Cancelled.chatTableHeading")}
            chatTableColumns={[`${t("booking_id")}`, `${t("patient_name")}`, `${t("medical_specialty")}`, `${t("time_&_date")}`, `${t("status")}`, loginData?.currencyCode, '']}
            onSearchClick={onSearchClick}
        />

    )
}

export default CancelledChats
